import { Button } from "@/components/ui/button";

interface SettingsFooterActionsProps {
  onCancel: () => void;
  onSave: () => void;
  isSaving?: boolean;
}

export function SettingsFooterActions({ onCancel, onSave, isSaving = false }: SettingsFooterActionsProps) {
  return (
    <div className="flex justify-end gap-4 mt-4">
      <Button
        type="button"
        size="sm"
        variant="outline"
        className="px-8 border-[#dc4426] text-[#dc4426] hover:bg-[#dc4426]/10"
        onClick={onCancel}
        disabled={isSaving}
      >
        Cancelar
      </Button>

      <Button
        type="button"
        size="sm"
        className="px-8 bg-[#0fc65c] text-[#0b0d17] hover:bg-[#0fc65c]/90"
        onClick={onSave}
        disabled={isSaving}
      >
        Salvar
      </Button>
    </div>
  );
}
